import gql from 'graphql-tag';

const GET_DEVICE_ROUND_BY_DEVICE_ID = gql`
  query GetDeviceRoundsByDevice($deviceId: ID!) {
    getDeviceRoundsByDevice(deviceId: $deviceId) {
      deviceRounds {
        id
        name
        deviceId
        dateInit
        dateEnd
        rrule
        duration
        recurrence
        color
        points {
          point {
            id
            identifier
            placeId
            name
            description
            latitude
            longitude
            type
            place {
              id
              street
              zipCode
              city
              state
              name
              coordinate
              workspaceId
              country {
                name
              }
            }
            channel {
              id
              channelId
              description
            }
          }
          id
          order
        }
      }
    }
  }
`;

const GET_DEVICE_ROUND_BY_ID = gql`
  query GetDeviceRoundById($roundId: ID!) {
    getDeviceRoundById(id: $roundId) {
      id
      name
      points {
        point {
          id
          identifier
          type
          channel {
            id
            channelId
            description
          }
        }
        id
        order
      }
    }
  }
`;

const GET_DEVICE_CCTV_ACTIVE_CHANNELS = gql`
  query GetDeviceCCTVActiveChannels($roundId: ID!, $situationId: ID) {
    getDeviceCCTVActiveChannels(roundId: $roundId, situationId: $situationId) {
      id
      channelId
      description
      pointId
      isMarked
    }
  }
`;

export default {
  GET_DEVICE_ROUND_BY_DEVICE_ID,
  GET_DEVICE_ROUND_BY_ID,
  GET_DEVICE_CCTV_ACTIVE_CHANNELS,
};
